import React, { memo, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { Container } from './modalOverlay.styles';
import { Animated } from '../animated';
import { TRANSITION_TOTAL_DURATION } from '../animated/animated.constants';

const ModalOverlayComponent = ({
  className,
  totalDuration,
  isVisible,
  children,
  onHideRequest,
  onEnter,
  onEntered,
  onExit,
  onExited,
}) => {
  const ref = useRef();

  const handleOutClick = e => {
    if (e.target === ref.current) {
      onHideRequest();
    }
  };

  return (
    <Animated
      totalDuration={totalDuration}
      visible={isVisible}
      onEnter={onEnter}
      onEntered={onEntered}
      onExit={onExit}
      onExited={onExited}
    >
      {ReactDOM.createPortal(
        <Container className={className} ref={ref} onClick={handleOutClick}>
          {children}
        </Container>,
        document.body
      )}
    </Animated>
  );
};

ModalOverlayComponent.propTypes = {
  className: PropTypes.string,
  totalDuration: PropTypes.number,
  isVisible: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onHideRequest: PropTypes.func.isRequired,
  onEnter: PropTypes.func,
  onEntered: PropTypes.func,
  onExit: PropTypes.func,
  onExited: PropTypes.func,
};

ModalOverlayComponent.defaultProps = {
  totalDuration: TRANSITION_TOTAL_DURATION,
};

export const ModalOverlay = memo(ModalOverlayComponent);
